/**
 * 设备
 */

// 模块文件配置
const { VITE_APP_AFTER } = import.meta.env
const prefix = VITE_APP_AFTER
export default [
  // 添加设备
  { name: 'insertBatchDevice', url: `${prefix}/insertBatchDevice`, method: 'post' },
  // 更改设备状态
  { name: 'updateBatchDeviceStatus', url: `${prefix}/updateBatchDeviceStatus`, method: 'post' },
  // 删除扫码器中的设备
  { name: 'deleteQRScannerDevice', url: `${prefix}/open/deleteQRScannerDevice`, method: 'post' },
  // 查询扫码器中的设备列表
  { name: 'selectQRScannerDeviceList', url: `${prefix}/open/selectQRScannerDeviceList`, method: 'get' },
  // 查询已添加设备所属管理区域
  { name: 'selectSearchDeviceThreeLevelLinkageAreaList', url: `${prefix}/selectSearchDeviceThreeLevelLinkageAreaList`, method: 'get' },
  // 查询设备分页列表
  { name: 'selectDevicePageList', url: `${prefix}/selectDevicePageList`, method: 'get' },
  // 获取绑定设备的经销商列表
  { name: 'selectBindingDeviceDealerUserList', url: `${prefix}/selectBindingDeviceDealerUserList`, method: 'get' },
  // 获取所有经销商下拉列表
  { name: 'selectSearchComboBoxDealerUserList', url: `${prefix}/selectSearchComboBoxDealerUserList`, method: 'get' },
  // 获取单台设备绑定的所有用户列表
  { name: 'selectOneDeviceBindingAllAppletUserList', url: `${prefix}/selectOneDeviceBindingAllAppletUserList`, method: 'get' },
  // 获取搜索设备经销商下拉列表
  { name: 'selectSearchDeviceComboBoxDealerUserList', url: `${prefix}/selectSearchDeviceComboBoxDealerUserList`, method: 'get' },
  // 添加成功或者关闭弹窗后 清除扫码枪设备
  { name: 'deleteAllQRScannerDevice', url: `${prefix}/open/deleteAllQRScannerDevice`, method: 'post' },
  // 删除设备
  { name: 'deleteDevice', url: `${prefix}/deleteDevice`, method: 'delete' },

  /* ---记录 */
  // 使用
  { name: 'selectDeviceUseCountRecordPageList', url: `${prefix}/selectDeviceUseCountRecordPageList`, method: 'get' },
  // 连接
  { name: 'selectDeviceConnectionCountRecordPageList', url: `${prefix}/selectDeviceConnectionCountRecordPageList`, method: 'get' },

]
